export default __webpack_public_path__ + "static/media/cross.aef08775.svg";